import React from "react";

export default function Button({
  children,
  type = "primary",
  fullWidth = false,
  loading = false,
  ...props
}) {

  const baseClasses = `flex items-center justify-center gap-2 rounded-[6px] px-4 py-2 font-medium transition-colors w-fit h-[40px]`;


  let typeClasses = "";
  switch (type) {
    case "primary":
      typeClasses =
        "bg-teal-600 hover:brightness-90 text-white";
       
      break;
    case "secondary":
      typeClasses = "border border-gray-400 text-gray-800 hover:bg-gray-200";
      break;
    case "delete":
      typeClasses = "bg-red-600 hover:bg-red-700";
      break;
    case "cancel":
      typeClasses = "bg-gray-400 hover:bg-gray-500";
      break;
    default:
      typeClasses =
        "bg-teal-600 hover:brightness-90";
  }

  return (
    <button
      className={`${baseClasses} ${typeClasses} disabled:opacity-50 disabled:cursor-not-allowed`}
      disabled={loading || props.disabled}
      {...props}
    >
      {children}
    </button>
  );
}
